export default {
      id: "call-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "app/svg/sprite.svg#call",
      toString: function () {
        return this.url;
      }
    }